export class UserSummaryItem {
  constructor(
    public readonly name: string,
    public readonly count: number,
    public readonly rate: number
  ) {}
}
